import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobTaskTableItemFragment = { __typename: 'JobTask', id: string, legacyId: number, attemptCount: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, maxAttempts: number, message?: string | null, name?: string | null, progress?: number | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, createdBy: { __typename: 'User', id: string, name: string }, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }> };

export type JobTaskTableItemsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type JobTaskTableItemsQuery = { __typename: 'Query', totalCount: number, items: Array<{ __typename: 'JobTask', id: string, legacyId: number, attemptCount: number, claimedBy?: string | null, deferredUntil?: string | null, finished?: string | null, maxAttempts: number, message?: string | null, name?: string | null, progress?: number | null, queueGroup?: string | null, resourceGroupPin?: Types.ResourceGroupId | null, started?: string | null, state: Types.JobTaskState, taskType?: string | null, createdBy: { __typename: 'User', id: string, name: string }, cascade: Array<{ __typename: 'JobTaskCascadeStep', resourceGroupId: Types.ResourceGroupId, label: string, platform: Types.ResourceGroupPlatform, status: Types.CascadeStepStatus, events: Array<{ __typename: 'JobTaskCascadeStepEvent', label: string, observedAt: string, message?: string | null, category: Types.CascadeStepEventCategory }> }> } | null> };

export const JobTaskTableItemFragmentDoc = gql`
    fragment JobTaskTableItem on JobTask {
  id
  legacyId
  attemptCount
  claimedBy
  createdBy {
    id
    name
  }
  deferredUntil
  finished
  maxAttempts
  message
  name
  progress
  queueGroup
  resourceGroupPin
  cascade {
    resourceGroupId
    label
    platform
    status
    events {
      label
      observedAt
      message
      category
    }
  }
  started
  state
  taskType
}
    `;
export const JobTaskTableItemsDocument = gql`
    query jobTaskTableItems($id: ID!) {
  items: jobTasks(
    filter: {jobId: {equals: $id}}
    take: 1000
    orderBy: [{key: legacyId, direction: asc}]
  ) {
    ...JobTaskTableItem
  }
  totalCount: jobTasksCount(filter: {jobId: {equals: $id}})
}
    ${JobTaskTableItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobTaskTableItemsGQL extends Apollo.Query<JobTaskTableItemsQuery, JobTaskTableItemsQueryVariables> {
    override document = JobTaskTableItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }